"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forkJoin = void 0;

var _ForkJoinObservable = require("./ForkJoinObservable");

var forkJoin = _ForkJoinObservable.ForkJoinObservable.create;
exports.forkJoin = forkJoin;